import axios from 'axios';

import {
  GET_RENTALS,
  GET_RENTAL,
  GET_ERRORS,
  GET_RENTALAPPLICATION,
  GET_RENTALAPPLICATIONS,
  RENTALS_LOADING,
} from './types';
import { tutorOfficeSignature } from 'utils/utils';

//Get Rentals
export const getRentals = () => (dispatch) => {
  dispatch(setRentalLoading());
  axios
    .get('/api/rentals')
    .then((res) => dispatch({ type: GET_RENTALS, payload: res.data }))
    .catch((err) =>
      dispatch({
        type: GET_RENTALS,
        payload: {},
      })
    );
};

//Get Rental with id
export const getRentalOfId = (id) => (dispatch) => {
  dispatch(setRentalLoading());
  axios
    .get(`/api/rentals/${id}`)
    .then((res) => dispatch({ type: GET_RENTAL, payload: res.data }))
    .catch((err) =>
      dispatch({
        type: GET_RENTAL,
        payload: {},
      })
    );
};

//Get Rental with user id
export const getRentalOfUserId = () => (dispatch) => {
  dispatch(setRentalLoading());
  axios
    .get(`/api/rentals/user/rental`)
    .then((res) => {
      dispatch({ type: GET_RENTALS, payload: res.data });
    })
    .catch((err) =>
      dispatch({
        type: GET_RENTALS,
        payload: {},
      })
    );
};

//CreateRental
export const createRental = (rentalData, history) => (dispatch) => {
  axios
    .post('/api/rentals', rentalData)
    .then((res) => {
      if (!rentalData.fromapp) {
        let devices = '';
        if (rentalData.ipad.available) {
          devices = devices + 'Ipad, ';
        }
        if (rentalData.mikrofon.available) {
          devices = devices + 'Mikrofon, ';
        }
        if (rentalData.stativ.available) {
          devices = devices + 'Stativ, ';
        }
        if (rentalData.wacom.available) {
          devices = devices + 'Wacom, ';
        }
        if (rentalData.webcam.available) {
          devices = devices + 'Webcam, ';
        }

        let todaydate = new Date().toUTCString();
        //Abgeschlossen HW ausgegeben
        if (rentalData.status === 'HW ausgegeben') {
          const mailData = {
            to: `${rentalData.email}`,
            text: `
          Dear ${rentalData.vorname} ${rentalData.name},

          The requested device(s) ${devices.slice(0, -2)} was/were handed out to you on ${todaydate.slice(0, -13)}.

          Best regards,
          Tutor Coordination Office
          `,
            htmltext: `<p>Dear ${rentalData.vorname} ${
              rentalData.name
            },</p></br> <p>The requested device(s) ${devices.slice(
              0,
              -2
            )} was/were handed out to you on ${todaydate.slice(0, -13)}.</p>
          </br> <p>Best regards,</p><p>Tutor Coordination Office</p>${tutorOfficeSignature}</br><i>Note: This is an auto-generated mail</i>`,
            subject: 'Confirmation - Rental hardware handed over',
          };
          axios.post(`/api/mail/sendusermail`, mailData).then((res) => {
            history.push('/rentals-overview');
          });
        } else if (rentalData.status === 'Abgeschlossen') {
          const mailData = {
            to: `${rentalData.email}`,
            text: `
          Dear ${rentalData.vorname} ${rentalData.name},

          Your rental device(s) ${devices.slice(0, -2)} was/were returned on ${todaydate.slice(0, -13)}.

          Best regards,
          Tutor Coordination Office
          `,
            htmltext: `<p>Dear ${rentalData.vorname} ${
              rentalData.name
            },</p></br> <p>Your rental device(s) ${devices.slice(
              0,
              -2
            )} was/were returned on ${todaydate.slice(0, -13)}.</p>
          </br> <p>Best regards,</p><p>Tutor Coordination Office</p>${tutorOfficeSignature}</br><i>Note: This is an auto-generated mail</i>`,
            subject: 'Confirmation - Rental hardware returned',
          };

          axios.post(`/api/mail/sendusermail`, mailData).then((res) => {
            history.push('/rentals-overview');
          });
        }
        history.push('/rentals-overview');
      } else {
        axios
          .post(`/api/rentals/application/${rentalData.appid}`, {
            status: 'Done',
          })
          .then((res) => {
            let devices = '';
            if (rentalData.ipad.available) {
              devices = devices + 'Ipad, ';
            }
            if (rentalData.mikrofon.available) {
              devices = devices + 'Mikrofon, ';
            }
            if (rentalData.stativ.available) {
              devices = devices + 'Stativ, ';
            }
            if (rentalData.wacom.available) {
              devices = devices + 'Wacom, ';
            }
            if (rentalData.webcam.available) {
              devices = devices + 'Webcam, ';
            }

            let todaydate = new Date().toUTCString();
            //Abgeschlossen HW ausgegeben
            if (rentalData.status === 'HW ausgegeben') {
              const mailData = {
                to: `${rentalData.email}`,
                text: `
                Dear ${rentalData.vorname} ${rentalData.name},
      
                The requested device(s) ${devices.slice(
                  0,
                  -2
                )} was/were handed out to you on ${todaydate.slice(0, -13)}.
      
                Best regards,
                Tutor Coordination Office
                `,
                htmltext: `<p>Dear ${rentalData.vorname} ${
                  rentalData.name
                },</p></br> <p>The requested device(s) ${devices.slice(
                  0,
                  -2
                )} was/were handed out to you on ${todaydate.slice(0, -13)}.</p>
                </br> <p>Best regards,</p><p>Tutor Coordination Office</p>${tutorOfficeSignature}</br><i>Note: This is an auto-generated mail</i>`,
                subject: 'Confirmation - Rental hardware handed over',
              };
              axios.post(`/api/mail/sendusermail`, mailData).then((res) => {
                history.push('/rentals-overview');
              });
            } else if (rentalData.status === 'Abgeschlossen') {
              const mailData = {
                to: `${rentalData.email}`,
                text: `
                Dear ${rentalData.vorname} ${rentalData.name},
      
                Your rental device(s) ${devices.slice(0, -2)} was/were returned on ${todaydate.slice(0, -13)}.
      
                Best regards,
                Tutor Coordination Office
                `,
                htmltext: `<p>Dear ${rentalData.vorname} ${
                  rentalData.name
                },</p></br> <p>Your rental device(s) ${devices.slice(
                  0,
                  -2
                )} was/were returned on ${todaydate.slice(0, -13)}.</p>
                </br> <p>Best regards,</p><p>Tutor Coordination Office</p>${tutorOfficeSignature}</br><i>Note: This is an auto-generated mail</i>`,
                subject: 'Confirmation - Rental hardware returned',
              };

              axios.post(`/api/mail/sendusermail`, mailData).then((res) => {
                history.push('/rentals-overview');
              });
            }
            history.push('/rentals-overview');
          });
      }
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

//UpdateRental
export const updateRental = (id, rentalData, history) => (dispatch) => {
  axios
    .post(`/api/rentals/${id}`, rentalData)
    .then((res) => {
      if (rentalData.oldstatus === rentalData.status) {
        history.push('/rentals-overview');
      } else {
        let devices = '';
        if (rentalData.ipad?.available) {
          devices = devices + 'Ipad, ';
        }
        if (rentalData.mikrofon?.available) {
          devices = devices + 'Mikrofon, ';
        }
        if (rentalData.stativ?.available) {
          devices = devices + 'Stativ, ';
        }
        if (rentalData.wacom?.available) {
          devices = devices + 'Wacom, ';
        }
        if (rentalData.webcam?.available) {
          devices = devices + 'Webcam, ';
        }

        let todaydate = new Date().toUTCString();
        //Abgeschlossen HW ausgegeben
        if (rentalData.status === 'HW ausgegeben') {
          const mailData = {
            to: `${rentalData.email}`,
            text: `
          Dear ${rentalData.vorname} ${rentalData.name},

          The requested device(s) ${devices.slice(0, -2)} was/were handed out to you on ${todaydate.slice(0, -13)}.

          Best regards,
          Tutor Coordination Office
          `,
            htmltext: `<p>Dear ${rentalData.vorname} ${
              rentalData.name
            },</p></br> <p>The requested device(s) ${devices.slice(
              0,
              -2
            )} was/were handed out to you on ${todaydate.slice(0, -13)}.</p>
          </br> <p>Best regards,</p><p>Tutor Coordination Office</p>${tutorOfficeSignature}</br><i>Note: This is an auto-generated mail</i>`,
            subject: 'Confirmation - Rental hardware handed over',
          };
          axios.post(`/api/mail/sendusermail`, mailData).then((res) => {
            history.push('/rentals-overview');
          });
        } else if (rentalData.status === 'Abgeschlossen') {
          const mailData = {
            to: `${rentalData.email}`,
            text: `
          Dear ${rentalData.vorname} ${rentalData.name},

          Your rental device(s) ${devices.slice(0, -2)} was/were returned on ${todaydate.slice(0, -13)}.

          Best regards,
          Tutor Coordination Office
          `,
            htmltext: `<p>Dear ${rentalData.vorname} ${
              rentalData.name
            },</p></br> <p>Your rental device(s) ${devices.slice(
              0,
              -2
            )} was/were returned on ${todaydate.slice(0, -13)}.</p>
          </br> <p>Best regards,</p><p>Tutor Coordination Office</p>${tutorOfficeSignature}</br><i>Note: This is an auto-generated mail</i>`,
            subject: 'Confirmation - Rental hardware returned',
          };

          axios.post(`/api/mail/sendusermail`, mailData).then((res) => {
            history.push('/rentals-overview');
          });
        }
      }
      history.push('/rentals-overview');
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data,
      });
    });
};

//Delete Rental
export const deleteRental = (id, history) => (dispatch) => {
  if (window.confirm('Sind Sie sicher? Dieser Vorgang kann NICHT rückgängig gemacht werden!')) {
    axios
      .delete(`/api/rentals/${id}`)
      .then((res) => {
        history.push('/rentals-overview');
      })
      .catch((err) =>
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data,
        })
      );
  }
};

//downloadRentalform
export const downloadRentalform = (rentalData) => (dispatch) => {
  axios({
    url: '/api/rentals/download/rentalform',
    method: 'POST',
    responseType: 'blob',
    data: rentalData,
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Leihschein-${rentalData.tumid}.pdf`);
    document.body.appendChild(link);
    link.click();
  });
};

//Get Rentalsapplications
export const getRentalsapplications = () => (dispatch) => {
  axios
    .get('/api/rentals/applications/all')
    .then((res) => dispatch({ type: GET_RENTALAPPLICATIONS, payload: res.data }))
    .catch((err) =>
      dispatch({
        type: GET_RENTALAPPLICATIONS,
        payload: {},
      })
    );
};

//Get Rental with id
export const getRentalsapplicationOfId = (id) => (dispatch) => {
  axios
    .get(`/api/rentals/application/${id}`)
    .then((res) => dispatch({ type: GET_RENTALAPPLICATION, payload: res.data }))
    .catch((err) => {
      console.log(err);
      dispatch({
        type: GET_RENTALAPPLICATION,
        payload: {},
      });
    });
};

//CreateRentalapplication
export const createRentalApplication = (rentalapplicationData, history) => (dispatch) => {
  axios
    .post('/api/rentals/application/new', rentalapplicationData)
    .then((res) => {
      window.alert('Thank you, your hardware request has been successfully received.');
      history.push('/dashboard');
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

export const setRentalLoading = () => {
  return {
    type: RENTALS_LOADING,
  };
};
